import { useState } from 'react'
import { Link } from '@tanstack/router'
import { useTranslation } from 'react-i18next'
import { styled } from '@linaria/react'

import { useBoundStore } from '../../store/store'
import { CASINO_CATEGORIES } from '../../constants/casino'

const Container = styled.div`
  margin-bottom: 50px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: start;
  padding: 0 20px;
  @media (min-width: 1200px) {
    width: 1200px;
    gap: 40px;
    margin: 0 auto 40px;
    display: flex;
    justify-content: space-between;
    padding: 0;
  }
`

const Column = styled.div`
  .title {
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    color: var(--highlight);
    text-transform: uppercase;
    margin-bottom: 12px;
  }
  p,
  a,
  button {
    display: block;
    color: var(--highlight);
    font-size: 12px;
    text-align: left;
    font-family: 'Inter', sans-serif;
    font-weight: 300;
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  a,
  button {
    transition: all 0.2s ease-in-out;
    &:hover {
      opacity: 0.7;
    }
  }
  svg {
    fill: var(--highlight);
  }
  @media (min-width: 1200px) {
    font-size: 16px;
    width: max-content;
    .title {
      font-size: 18px;
      margin-bottom: 12px;
    }
    p,
    a,
    button {
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
`

// const SocialMedia = styled.div`
//   gap: 12px;
//   margin-top: 8px;
//   img {
//     max-width: 27px;
//     max-height: 27px;
//   }
//   a,
//   div {
//     margin: 0;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 48px;
//   }
//   @media (min-width: 1200px) {
//     margin-top: 14px;
//     img {
//       max-width: 32px;
//       max-height: 32px;
//     }
//   }
// `
const DropdownMenu = styled.div<{ isOpen: boolean }>`
  max-height: ${props => (props.isOpen ? '250px' : '0')};
  overflow: hidden;
  transition: all 0.3s;
  a {
    display: block;
    text-decoration: none;
    text-transform: capitalize;
  }
  a:last-child {
    margin-bottom: 8px;
  }
`

const FooterLinks = () => {
  const { t, i18n } = useTranslation(['drawer', 'footer'])
  const { language } = i18n
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const setIsPendingDepositVisible = useBoundStore(
    state => state.common.setIsPendingDepositVisible,
  )
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const toggleDropdown = () => {
    setIsDropdownOpen(prev => !prev)
  }

  return (
    <Container>
      <Column>
        <p className="title">{t('information', { ns: 'footer' })}</p>
        <Link to="/help/$page" params={{ page: 'we' }}>
          {t('about-us', { ns: 'footer' })}
        </Link>
        <Link
          to="/help/$page"
          params={{
            page:
              language === 'en'
                ? 'terms-and-conditions'
                : 'terminos-y-condiciones',
          }}>
          {t('terms-and-conditions', { ns: 'footer' })}
        </Link>
        <Link to="/help/$page" params={{ page: 'juego-responsable' }}>
          {t('responsible-gaming', { ns: 'footer' })}
        </Link>
        <Link
          to="/help/$page"
          params={{ page: 'privacy-notice-and-site-cookies' }}>
          {t('privacy-notice-and-site-cookies', { ns: 'footer' })}
        </Link>
        <Link to="/help/$page" params={{ page: 'affiliate-program' }}>
          {t('affiliate-program', { ns: 'footer' })}
        </Link>
        <Link to="/help/$page" params={{ page: 'betting-mechanics' }}>
          {t('betting-mechanics', { ns: 'footer' })}
        </Link>
        <Link to="/help/$page" params={{ page: 'betting-conditions' }}>
          {t('betting-conditions', { ns: 'footer' })}
        </Link>
      </Column>
      <Column>
        <p className="title">{t('our-sections', { ns: 'footer' })}</p>
        <Link
          to={
            +pending_bind === 0 || +pending_bind === 2 ? undefined : '/sports'
          }
          onClick={() => {
            if (+pending_bind === 0 || +pending_bind === 2)
              setIsPendingDepositVisible(true)
          }}>
          {t('sports', { ns: 'drawer' })}
        </Link>
        <button onClick={toggleDropdown}>Juegos</button>
        <DropdownMenu isOpen={isDropdownOpen}>
          {CASINO_CATEGORIES.slice(0, -1).map(category => (
            <Link
              key={category.value}
              to={'/casino/$category'}
              params={{ category: category.label }}>
              {category.label.toLowerCase()}
            </Link>
          ))}
        </DropdownMenu>
        <Link to="/promotions">{t('promotions', { ns: 'footer' })}</Link>
      </Column>
      <Column>
        <p className="title">{t('help', { ns: 'footer' })}</p>
        <Link to="/help/$page" params={{ page: 'faq' }}>
          {t('faqs', { ns: 'footer' })}
        </Link>
        <Link to="/help/$page" params={{ page: 'deposit' }}>
          {t('deposit', { ns: 'footer' })}
        </Link>
        <Link to="/help/$page" params={{ page: 'withdraw' }}>
          {t('withdraw', { ns: 'footer' })}
        </Link>
        <Link to="/help/$page" params={{ page: 'refund-policy' }}>
          {t('refund-policy', { ns: 'footer' })}
        </Link>
      </Column>
      <Column>
        <p className="title">{t('contact-us', { ns: 'footer' })}</p>
        <Link to="/contact-us" style={{ cursor: 'pointer' }}>
          ¡Contáctenos
        </Link>
        {/* <a href="mailto:info@fun88.mx" target="_blank" rel="noreferrer">
          {t('email')}: info@fun88.mx
        </a>
        <p>{t('phone')}: +52 553 398 16 92</p> */}
        {/* <SocialMedia className="flx-str-ctr">
          <a
            aria-label="instagram page"
            href="https://www.instagram.com/fun88.mx/"
            target="blank">
            <Icon id="instagram" width="36" height="36" />
          </a>
          <a
            aria-label="twitter page"
            href="https://twitter.com/mexplay_mx"
            target="blank">
            <Icon id="twitter" width="39" height="42" />
          </a>
          <a
            aria-label="facebook-page"
            href="https://www.facebook.com/fun88.mx"
            target="blank">
            <Icon id="facebook-f" width="20" height="36" />
          </a>
          <div>
            <Icon id="18-plus" width="38" height="38" />
          </div>
        </SocialMedia> */}
      </Column>
    </Container>
  )
}

export default FooterLinks
